import React from 'react';
const paths = {
  jarvis:'m12 3 2.5 6.5L21 12l-6.5 2.5L12 21l-2.5-6.5L3 12l6.5-2.5Z',
  teach:'m3 8 9-5 9 5-9 5Zm3 2v7l6 4 6-4v-7',
  watch:'M5 21V3h13l-3 5 3 5H5',
  active:'M3 6h11v11H3ZM14 10h4l3 4v3h-7M6 17v3m12-3v3',
  map:'m3 5 6-2 6 2 6-2v16l-6 2-6-2-6 2Zm6-2v16m6-14v16',
  sheets:'M6 3h9l4 4v14H6ZM14 3v5h5M9 12h7m-7 4h7',
  inbox:'M3 14 6 5h12l3 9v6H3Zm0 0h5l2 3h4l2-3h5',
  calls:'M3 4h18v13H9l-6 4Zm5 5h8m-8 4h5',
  phone:'M7 3H4l-1 3c1 8 7 14 15 15l3-1v-4l-5-2-2 2-6-6 2-2Z',
  customers:'M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-7 10v-3a7 7 0 0 1 14 0v3m1-17a4 4 0 0 1 0 8m2 3a5 5 0 0 1 3 5',
  geofences:'M12 3a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM12 7a4 4 0 1 0 0 8 4 4 0 0 0 0-8ZM12 1v3m0 14v5M1 11h3m14 0h5',
  missing:'m3 7 9-4 9 4v11l-9 4-9-4Zm0 0 9 4 9-4m-9 4v11M7 5l9 4',
  roadcalls:'m12 3 10 18H2Zm0 6v5m0 3v1',
  drivers:'M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM4 21v-3a8 8 0 0 1 16 0v3Z',
  employees:'M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM2 21v-3a7 7 0 0 1 14 0v3m1-16a3 3 0 0 1 0 6m2 4 3 6',
  outbound:'M3 21V11h4v10Zm7 0V6h4v15Zm7 0V2h4v19Z',
  unclosed:'M4 5h16v16H4ZM8 2v6m8-6v6M4 10h16',
  delivered:'M20 11a8 8 0 1 1-5-7M8 10l4 4 9-10',
};
export default function DispatchNavIcon({name}) { return <svg className="dispatch-nav-icon" aria-hidden="true" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d={paths[name] || paths.jarvis}/></svg>; }
